import { render } from "./MdFile.vue?vue&type=template&id=054c4a50"
import script from "./MdFile.vue?vue&type=script&lang=js"
export * from "./MdFile.vue?vue&type=script&lang=js"

import "./MdFile.vue?vue&type=style&index=0&id=054c4a50&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__